import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Button,
  Radio,
  Dropdown,
  Input
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardConfirmCoverageUX = (props: any) => {
    return(
      <div
        id="CardConfirmCoverageUX-div-0"
        style={{ width: "100%", height: "100%" , padding: "15px"}}>
        <Form
          id="CardConfirmCoverageUX-Form-66">
          <FormGroup
            id="CardConfirmCoverageUX-FormGroup-67"
            inline={true}>
            <FormField
              id="CardConfirmCoverageUX-FormField-68"
              inline={true}>
              <label
                id="CardConfirmCoverageUX-label-77">
                {props.languageUX === "en" ? "List of Coverages" : "รายชื่อสิทธิ"}
              </label>
            </FormField>
            <FormField
              id="CardConfirmCoverageUX-FormField-69"
              inline={true}
              style={{flex: 1}}>
            </FormField>
            <FormField
              id="CardConfirmCoverageUX-FormField-70"
              inline={true}>
              <Button
                color="blue"
                id="btn-addCoverage"
                onClick={props.onNewCoverage}
                size="small">
                {props.languageUX === "en" ? "Add Coverage" : "เพิ่มสิทธิการรักษา"}
              </Button>
            </FormField>
          </FormGroup>
        </Form>
        <Form
          id="CardConfirmCoverageUX-Form-71">
          <Table
            data={props.coverageList}
            getTrProps={props.rowProps}
            headers={props.languageUX === "en" ? "Coverage Name,Payer Name,Service Type,Priority,Status" : "ชื่อสิทธิการรักษา,ผู้จ่าย,ประเภทบริการ,ลำดับสิทธิ,สถานะ"}
            id="tb-coverage"
            keys="coverage_name,payer_name,service_type_name,priority,status"
            minRows={3}
            showPagination={false}
            style={{height: "150px"}}>
          </Table>
        </Form>
        <Form
          id="CardConfirmCoverageUX-Form-73">
          <FormField
            id="CardConfirmCoverageUX-FormField-79">
            <label
              id="CardConfirmCoverageUX-label-80"
              style={{paddingTop: "1rem"}}>
              {props.languageUX === "en" ? "Coverage Information (Add new)" : "ข้อมูลสิทธิ (สร้างใหม่)"}
            </label>
          </FormField>
        </Form>
        <Form
          id="CardConfirmCoverageUX-Form-75">
          <FormGroup
            id="CardConfirmCoverageUX-FormGroup-76"
            inline={true}>
            <FormField
              className="required"
              id="CardConfirmCoverageUX-FormField-81"
              inline={true}
              style={{marginRight: "0.5rem"}}>
              <label
                id="CardConfirmCoverageUX-label-88"
                style={{color: "red", fontWeight: "normal", minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Service type" : "ประเภทบริการ"}
              </label>
            </FormField>
            <FormField
              id="CardConfirmCoverageUX-FormField-82"
              inline={true}>
              <Radio
                checked={props.service_type === "O"}
                id="rdo-opd"
                label={props.languageUX === "en" ? "OPD" : "ผู้ป่วยนอก"}
                onChange={props.changeCoverage("service_type", "O")}>
              </Radio>
            </FormField>
            <FormField
              id="CardConfirmCoverageUX-FormField-83"
              inline={true}
              style={{marginRight: "0.5rem"}}>
              <Radio
                checked={props.service_type === "I"}
                id="rdo-ipd"
                label={props.languageUX === "en" ? "IPD" : "ผู้ป่วยใน"}
                onChange={props.changeCoverage("service_type", "I")}>
              </Radio>
            </FormField>
            <FormField
              id="CardConfirmCoverageUX-FormField-84"
              inline={true}>
              <label
                id="CardConfirmCoverageUX-label-91"
                style={{fontWeight: "normal"}}>
                {props.languageUX === "en" ? "Coverage priority" : "ลำดับการเลือกใช้สิทธิ"}
              </label>
            </FormField>
            <FormField
              id="CardConfirmCoverageUX-FormField-85"
              inline={true}
              style={{marginRight: "0.5rem"}}
              width={3}>
              <Dropdown
                clearable={true}
                fluid={true}
                id="cb-priority"
                onChange={props.changeCoverage("priority")}
                options={props.priorityOptions}
                search={true}
                selection={true}
                style={{minWidth: "100%", width: 0}}
                value={props.priority}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardConfirmCoverageUX-FormField-86"
              inline={true}>
              <Radio
                checked={props.active}
                id="rdo-claim"
                label={props.languageUX === "en" ? "Certified coverage" : "รับรองสิทธิ"}
                onChange={props.changeCoverage("active", true)}>
              </Radio>
            </FormField>
            <FormField
              id="CardConfirmCoverageUX-FormField-87"
              inline={true}>
              <Radio
                checked={!props.active}
                id="rdo-suspendClaim"
                label={props.languageUX === "en" ? "Deactivate coverage" : "ระงับสิทธิ"}
                onChange={props.changeCoverage("active", false)}>
              </Radio>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardConfirmCoverageUX-FormGroup-95">
            <FormField
              className="required"
              id="CardConfirmCoverageUX-FormField-97"
              width={8}>
              <label
                id="CardConfirmCoverageUX-label-101"
                style={{color: "red", fontWeight: "normal"}}>
                {props.languageUX === "en" ? "Coverage" : "สิทธิ"}
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                id="cb-coverage"
                onChange={props.changeCoverage("coverage")}
                options={props.coverageOptions}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.coverage}>
              </Dropdown>
            </FormField>
            <FormField
              className="required"
              id="CardConfirmCoverageUX-FormField-98"
              width={8}>
              <label
                id="CardConfirmCoverageUX-label-102"
                style={{color: "red", fontWeight: "normal"}}>
                {props.languageUX === "en" ? "Coverage type" : "ประเภทสิทธิ"}
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                id="cb-assureType"
                onChange={props.changeCoverage("assure_type")}
                options={props.assureTypeOptions}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.assure_type}>
              </Dropdown>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardConfirmCoverageUX-FormGroup-96">
            <div
              className="eight wide field"
              id="CardConfirmCoverageUX-div-109">
              {props.searchBoxPayer}
            </div>
            <FormField
              id="CardConfirmCoverageUX-FormField-100"
              width={8}>
              <label
                id="CardConfirmCoverageUX-label-104"
                style={{fontWeight: "normal"}}>
                {props.languageUX === "en" ? "Primary hospital code" : "รหัสสถานพยาบาลหลัก"}
              </label>
              <Input
                fluid={true}
                id="txt-hosCode"
                onChange={props.changeCoverage("main_hospital_code")}
                value={props.main_hospital_code}>
              </Input>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardConfirmCoverageUX-FormGroup-111">
            <FormField
              id="CardConfirmCoverageUX-FormField-112"
              width={4}>
              <label
                id="CardConfirmCoverageUX-label-114"
                style={{color: "red", fontWeight: "normal"}}>
                {props.languageUX === "en" ? "Start date*" : "วันที่เริ่ม*"}
              </label>
              <DateTextBox
                id="dt-startDateCLM"
                onChange={props.changeDate("start_date")}
                value={props.start_date}>
              </DateTextBox>
            </FormField>
            <FormField
              id="CardConfirmCoverageUX-FormField-113"
              width={4}>
              <label
                id="CardConfirmCoverageUX-label-115"
                style={{fontWeight: "normal"}}>
                {props.languageUX === "en" ? "Expiry date" : "วันหมดอายุ"}
              </label>
              <DateTextBox
                id="dt-endDateCLM"
                onChange={props.changeDate("stop_date")}
                value={props.stop_date}>
              </DateTextBox>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardConfirmCoverageUX-FormGroup-118">
            <FormField
              id="CardConfirmCoverageUX-FormField-120"
              width={16}>
              <hr
                id="CardConfirmCoverageUX-hr-121">
              </hr>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardConfirmCoverageUX-FormGroup-122">
            <FormField
              id="CardConfirmCoverageUX-FormField-123">
              <label
                id="CardConfirmCoverageUX-label-124">
                {props.languageUX === "en" ? "Refer-in" : "ผู้ป่วยที่ถูกส่งตัวมาจากสถานพยาบาลอื่น"}
              </label>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardConfirmCoverageUX-FormGroup-125"
            inline={true}>
            <FormField
              id="CardConfirmCoverageUX-FormField-126"
              inline={true}
              width={5}>
              <label
                id="CardConfirmCoverageUX-label-128"
                style={{fontWeight: "normal", minWidth: "55px", maxWidth: "55px"}}>
                {props.languageUX === "en" ? "Referer:" : "ผู้ส่งตัว"}
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardConfirmCoverageUX-Dropdown-130"
                onChange={props.changeCoverage("referer")}
                options={props.refererOptions}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.referer}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardConfirmCoverageUX-FormField-127"
              inline={true}
              width={5}>
              <label
                id="CardConfirmCoverageUX-label-129"
                style={{fontWeight: "normal", width: "100%", maxWidth: "max-content"}}>
                {props.languageUX === "en" ? "Refer date:" : "วันที่ส่งตัว"}
              </label>
              <div
                id="CardConfirmCoverageUX-div-131"
                style={{width: "100%"}}>
                
                <DateTextBox
                  id="CardConfirmCoverageUX-DateTextBox-132"
                  onChange={props.changeDate("refer_date")}
                  value={props.refer_date}>
                </DateTextBox>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardConfirmCoverageUX-FormGroup-133"
            inline={true}>
            <FormField
              id="CardConfirmCoverageUX-FormField-134"
              inline={true}
              width={16}>
              <label
                id="CardConfirmCoverageUX-label-135"
                style={{fontWeight: "normal", minWidth: "55px", maxWidth: "55px"}}>
                {props.languageUX === "en" ? "Refer No." : "เลขที่อ้างอิง"}
              </label>
              <Input
                fluid={true}
                id="CardConfirmCoverageUX-Input-136"
                onChange={props.changeCoverage("refer_no")}
                value={props.refer_no}>
              </Input>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardConfirmCoverageUX-FormGroup-137"
            inline={true}>
            <FormField
              id="CardConfirmCoverageUX-FormField-138"
              inline={true}
              width={10}>
              <label
                id="CardConfirmCoverageUX-label-139"
                style={{fontWeight: "normal", minWidth: "55px", maxWidth: "55px"}}>
                {props.languageUX === "en" ? "Service Point" : "จุดบริการ"}
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardConfirmCoverageUX-Dropdown-140"
                multiple={true}
                onChange={props.changeCoverage("service_point")}
                options={props.servicePointOptions}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.servicePoint}>
              </Dropdown>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardConfirmCoverageUX-FormGroup-141"
            inline={true}>
            <FormField
              id="CardConfirmCoverageUX-FormField-142"
              inline={true}
              style={{flex:1}}>
            </FormField>
            <FormField
              id="CardConfirmCoverageUX-FormField-143"
              inline={true}>
              <Button
                color="green"
                id="btn-saveCoverage"
                loading={props.loadingSave}
                onClick={props.onSave}
                size="small">
                {props.button_save}
              </Button>
            </FormField>
          </FormGroup>
        </Form>
      </div>
    )
}


export default CardConfirmCoverageUX

export const screenPropsDefault = {"language":"EN","searchBoxPayer":"[SearchBox Payer]"}

/* Date Time : Thu Nov 20 2025 07:17:10 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", height: \"100%\" , padding: \"15px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 66,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-Form-66"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 67,
      "name": "FormGroup",
      "parent": 66,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-FormGroup-67"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 68,
      "name": "FormField",
      "parent": 67,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-FormField-68"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 69,
      "name": "FormField",
      "parent": 67,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-FormField-69"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1}"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 70,
      "name": "FormField",
      "parent": 67,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-FormField-70"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 71,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-Form-71"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 72,
      "name": "Table",
      "parent": 71,
      "props": {
        "data": {
          "type": "code",
          "value": "props.coverageList"
        },
        "getTdProps": {
          "type": "code",
          "value": ""
        },
        "getTrProps": {
          "type": "code",
          "value": "props.rowProps"
        },
        "headers": {
          "type": "value",
          "value": "ชื่อสิทธิการรักษา,ผู้จ่าย,ประเภทบริการ,ลำดับสิทธิ,สถานะ",
          "valueEN": "Coverage Name,Payer Name,Service Type,Priority,Status"
        },
        "id": {
          "type": "value",
          "value": "tb-coverage"
        },
        "keys": {
          "type": "value",
          "value": "coverage_name,payer_name,service_type_name,priority,status"
        },
        "minRows": {
          "type": "code",
          "value": "3"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"150px\"}"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 73,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-Form-73"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 75,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-Form-75"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 76,
      "name": "FormGroup",
      "parent": 75,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-FormGroup-76"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": null,
      "id": 77,
      "name": "label",
      "parent": 68,
      "props": {
        "children": {
          "type": "value",
          "value": "รายชื่อสิทธิ",
          "valueEN": "List of Coverages"
        },
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-label-77"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 78,
      "name": "Button",
      "parent": 70,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่มสิทธิการรักษา",
          "valueEN": "Add Coverage"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "btn-addCoverage"
        },
        "onClick": {
          "type": "code",
          "value": "props.onNewCoverage"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 79,
      "name": "FormField",
      "parent": 73,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-FormField-79"
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": null,
      "id": 80,
      "name": "label",
      "parent": 79,
      "props": {
        "children": {
          "type": "value",
          "value": "ข้อมูลสิทธิ (สร้างใหม่)",
          "valueEN": "Coverage Information (Add new)"
        },
        "className": {
          "type": "value",
          "value": "",
          "valueEN": ""
        },
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-label-80"
        },
        "style": {
          "type": "code",
          "value": "{paddingTop: \"1rem\"}"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 81,
      "name": "FormField",
      "parent": 76,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-FormField-81"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.5rem\"}"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 82,
      "name": "FormField",
      "parent": 76,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-FormField-82"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 83,
      "name": "FormField",
      "parent": 76,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-FormField-83"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.5rem\"}"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 84,
      "name": "FormField",
      "parent": 76,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-FormField-84"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 85,
      "name": "FormField",
      "parent": 76,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-FormField-85"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.5rem\"}"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 86,
      "name": "FormField",
      "parent": 76,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-FormField-86"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 87,
      "name": "FormField",
      "parent": 76,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-FormField-87"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": null,
      "id": 88,
      "name": "label",
      "parent": 81,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทบริการ",
          "valueEN": "Service type"
        },
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-label-88"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\", fontWeight: \"normal\", minWidth: \"max-content\"}"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 89,
      "name": "Radio",
      "parent": 82,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.service_type === \"O\""
        },
        "id": {
          "type": "value",
          "value": "rdo-opd"
        },
        "label": {
          "type": "value",
          "value": "ผู้ป่วยนอก",
          "valueEN": "OPD"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeCoverage(\"service_type\", \"O\")"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 90,
      "name": "Radio",
      "parent": 83,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.service_type === \"I\""
        },
        "id": {
          "type": "value",
          "value": "rdo-ipd"
        },
        "label": {
          "type": "value",
          "value": "ผู้ป่วยใน",
          "valueEN": "IPD"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeCoverage(\"service_type\", \"I\")"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": null,
      "id": 91,
      "name": "label",
      "parent": 84,
      "props": {
        "children": {
          "type": "value",
          "value": "ลำดับการเลือกใช้สิทธิ",
          "valueEN": "Coverage priority"
        },
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-label-91"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 92,
      "name": "Dropdown",
      "parent": 85,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "cb-priority"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeCoverage(\"priority\")"
        },
        "options": {
          "type": "code",
          "value": "props.priorityOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"100%\", width: 0}"
        },
        "value": {
          "type": "code",
          "value": "props.priority"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 93,
      "name": "Radio",
      "parent": 86,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.active"
        },
        "disabled": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "rdo-claim"
        },
        "label": {
          "type": "value",
          "value": "รับรองสิทธิ",
          "valueEN": "Certified coverage"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeCoverage(\"active\", true)"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 94,
      "name": "Radio",
      "parent": 87,
      "props": {
        "checked": {
          "type": "code",
          "value": "!props.active"
        },
        "id": {
          "type": "value",
          "value": "rdo-suspendClaim"
        },
        "label": {
          "type": "value",
          "value": "ระงับสิทธิ",
          "valueEN": "Deactivate coverage"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeCoverage(\"active\", false)"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 95,
      "name": "FormGroup",
      "parent": 75,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-FormGroup-95"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 96,
      "name": "FormGroup",
      "parent": 75,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-FormGroup-96"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 97,
      "name": "FormField",
      "parent": 95,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-FormField-97"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 98,
      "name": "FormField",
      "parent": 95,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-FormField-98"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 100,
      "name": "FormField",
      "parent": 96,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-FormField-100"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": null,
      "id": 101,
      "name": "label",
      "parent": 97,
      "props": {
        "children": {
          "type": "value",
          "value": "สิทธิ",
          "valueEN": "Coverage"
        },
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-label-101"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\", fontWeight: \"normal\"}"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": null,
      "id": 102,
      "name": "label",
      "parent": 98,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทสิทธิ",
          "valueEN": "Coverage type"
        },
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-label-102"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\", fontWeight: \"normal\"}"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": null,
      "id": 104,
      "name": "label",
      "parent": 100,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัสสถานพยาบาลหลัก",
          "valueEN": "Primary hospital code"
        },
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-label-104"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 105,
      "name": "Dropdown",
      "parent": 97,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "cb-coverage"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeCoverage(\"coverage\")"
        },
        "options": {
          "type": "code",
          "value": "props.coverageOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.coverage"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 106,
      "name": "Dropdown",
      "parent": 98,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "cb-assureType"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeCoverage(\"assure_type\")"
        },
        "options": {
          "type": "code",
          "value": "props.assureTypeOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.assure_type"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": null,
      "id": 109,
      "name": "div",
      "parent": 96,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchBoxPayer"
        },
        "className": {
          "type": "value",
          "value": "eight wide field"
        },
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-div-109"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 110,
      "name": "Input",
      "parent": 100,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "txt-hosCode"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeCoverage(\"main_hospital_code\")"
        },
        "value": {
          "type": "code",
          "value": "props.main_hospital_code"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 111,
      "name": "FormGroup",
      "parent": 75,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-FormGroup-111"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 112,
      "name": "FormField",
      "parent": 111,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-FormField-112"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 113,
      "name": "FormField",
      "parent": 111,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-FormField-113"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": null,
      "id": 114,
      "name": "label",
      "parent": 112,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่เริ่ม*",
          "valueEN": "Start date*"
        },
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-label-114"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\", fontWeight: \"normal\"}"
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": null,
      "id": 115,
      "name": "label",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": "วันหมดอายุ",
          "valueEN": "Expiry date"
        },
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-label-115"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 116,
      "name": "DateTextBox",
      "parent": 112,
      "props": {
        "id": {
          "type": "value",
          "value": "dt-startDateCLM"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeDate(\"start_date\")"
        },
        "value": {
          "type": "code",
          "value": "props.start_date"
        }
      },
      "seq": 116,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 117,
      "name": "DateTextBox",
      "parent": 113,
      "props": {
        "id": {
          "type": "value",
          "value": "dt-endDateCLM"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeDate(\"stop_date\")"
        },
        "value": {
          "type": "code",
          "value": "props.stop_date"
        }
      },
      "seq": 117,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 118,
      "name": "FormGroup",
      "parent": 75,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-FormGroup-118"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "widths": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 118,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 120,
      "name": "FormField",
      "parent": 118,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-FormField-120"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 120,
      "void": false
    },
    {
      "from": null,
      "id": 121,
      "name": "hr",
      "parent": 120,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-hr-121"
        }
      },
      "seq": 121,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 122,
      "name": "FormGroup",
      "parent": 75,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-FormGroup-122"
        }
      },
      "seq": 122,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 123,
      "name": "FormField",
      "parent": 122,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-FormField-123"
        }
      },
      "seq": 123,
      "void": false
    },
    {
      "from": null,
      "id": 124,
      "name": "label",
      "parent": 123,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ป่วยที่ถูกส่งตัวมาจากสถานพยาบาลอื่น",
          "valueEN": "Refer-in"
        },
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-label-124"
        }
      },
      "seq": 124,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 125,
      "name": "FormGroup",
      "parent": 75,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-FormGroup-125"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 125,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 126,
      "name": "FormField",
      "parent": 125,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-FormField-126"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 126,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 127,
      "name": "FormField",
      "parent": 125,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-FormField-127"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 127,
      "void": false
    },
    {
      "from": null,
      "id": 128,
      "name": "label",
      "parent": 126,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ส่งตัว",
          "valueEN": "Referer:"
        },
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-label-128"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"55px\", maxWidth: \"55px\"}"
        }
      },
      "seq": 128,
      "void": false
    },
    {
      "from": null,
      "id": 129,
      "name": "label",
      "parent": 127,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่ส่งตัว",
          "valueEN": "Refer date:"
        },
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-label-129"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", width: \"100%\", maxWidth: \"max-content\"}"
        }
      },
      "seq": 129,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 130,
      "name": "Dropdown",
      "parent": 126,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-Dropdown-130"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeCoverage(\"referer\")"
        },
        "options": {
          "type": "code",
          "value": "props.refererOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.referer"
        }
      },
      "seq": 130,
      "void": false
    },
    {
      "from": null,
      "id": 131,
      "name": "div",
      "parent": 127,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-div-131"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 131,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 132,
      "name": "DateTextBox",
      "parent": 131,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-DateTextBox-132"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeDate(\"refer_date\")"
        },
        "value": {
          "type": "code",
          "value": "props.refer_date"
        }
      },
      "seq": 132,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 133,
      "name": "FormGroup",
      "parent": 75,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-FormGroup-133"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 133,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 134,
      "name": "FormField",
      "parent": 133,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-FormField-134"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 134,
      "void": false
    },
    {
      "from": null,
      "id": 135,
      "name": "label",
      "parent": 134,
      "props": {
        "children": {
          "type": "value",
          "value": "เลขที่อ้างอิง",
          "valueEN": "Refer No."
        },
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-label-135"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"55px\", maxWidth: \"55px\"}"
        }
      },
      "seq": 135,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 136,
      "name": "Input",
      "parent": 134,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-Input-136"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeCoverage(\"refer_no\")"
        },
        "value": {
          "type": "code",
          "value": "props.refer_no"
        }
      },
      "seq": 136,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 137,
      "name": "FormGroup",
      "parent": 75,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-FormGroup-137"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 137,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 138,
      "name": "FormField",
      "parent": 137,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-FormField-138"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "10"
        }
      },
      "seq": 138,
      "void": false
    },
    {
      "from": null,
      "id": 139,
      "name": "label",
      "parent": 138,
      "props": {
        "children": {
          "type": "value",
          "value": "จุดบริการ",
          "valueEN": "Service Point"
        },
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-label-139"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\", minWidth: \"55px\", maxWidth: \"55px\"}"
        }
      },
      "seq": 139,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 140,
      "name": "Dropdown",
      "parent": 138,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-Dropdown-140"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeCoverage(\"service_point\")"
        },
        "options": {
          "type": "code",
          "value": "props.servicePointOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.servicePoint"
        }
      },
      "seq": 140,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 141,
      "name": "FormGroup",
      "parent": 75,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-FormGroup-141"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 141,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 142,
      "name": "FormField",
      "parent": 141,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-FormField-142"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        }
      },
      "seq": 142,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 143,
      "name": "FormField",
      "parent": 141,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConfirmCoverageUX-FormField-143"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 143,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 144,
      "name": "Button",
      "parent": 143,
      "props": {
        "children": {
          "type": "code",
          "value": "props.button_save"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "btn-saveCoverage"
        },
        "loading": {
          "type": "code",
          "value": "props.loadingSave"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSave"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 144,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 85,
  "isMounted": false,
  "memo": false,
  "name": "CardConfirmCoverageUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "EN",
    "searchBoxPayer": "[SearchBox Payer]"
  },
  "width": 65
}

*********************************************************************************** */
